"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.QuestionList = void 0;
var _react = require("react");
var _constants = require("../../constants");
var _hooks = require("../../hooks");
var _QuestionItem = require("../QuestionItem/QuestionItem");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const QuestionList = (param)=>{
    let { questionList, isShowMoreEnabled, truncate } = param;
    const { translations } = (0, _hooks.useTranslations)();
    const [questionListToRender, setQuestionListToRender] = (0, _react.useState)(questionList);
    const [amountItemsToRender, setAmountItemsToRender] = (0, _react.useState)(_constants.MAX_AMOUNT_ITEMS_TO_RENDER);
    const handleShowMore = (0, _react.useCallback)(()=>{
        if (!(questionList.length === questionListToRender.length)) {
            const itemsToRender = amountItemsToRender + _constants.MAX_AMOUNT_ITEMS_TO_RENDER;
            setAmountItemsToRender(itemsToRender);
            setQuestionListToRender(questionList.slice(0, itemsToRender));
            return;
        }
        setAmountItemsToRender(_constants.MAX_AMOUNT_ITEMS_TO_RENDER);
        setQuestionListToRender(questionList.slice(0, _constants.MAX_AMOUNT_ITEMS_TO_RENDER));
    }, [
        amountItemsToRender,
        questionList,
        questionListToRender.length
    ]);
    (0, _react.useEffect)(()=>{
        let preparedList = [];
        if (isShowMoreEnabled && questionList.length > _constants.MAX_AMOUNT_ITEMS_TO_RENDER) {
            preparedList = questionList.slice(0, _constants.MAX_AMOUNT_ITEMS_TO_RENDER);
        } else {
            preparedList = questionList;
        }
        setQuestionListToRender(preparedList);
    }, [
        questionList,
        isShowMoreEnabled
    ]);
    let loadMoreButton = null;
    if (isShowMoreEnabled && questionList.length > _constants.MAX_AMOUNT_ITEMS_TO_RENDER) {
        loadMoreButton = /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Button, {
            type: "button",
            onClick: handleShowMore,
            children: questionList.length === questionListToRender.length ? translations.hide : translations.showMore
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        children: [
            questionListToRender.map((questionItem)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_QuestionItem.QuestionItem, {
                    questionItem: questionItem,
                    truncate: truncate
                }, questionItem.question)),
            loadMoreButton
        ]
    });
};
exports.QuestionList = QuestionList;
